@if (isInitialized) {
  <oe-modal [title]="this.component.alias" [component]="component" [formGroup]="formGroup">
    <oe-modal-horizontal-line></oe-modal-horizontal-line>
    <oe-modal-buttons [formGroup]="formGroup" controlName="mode" [component]="component" [buttons]=btns>
    </oe-modal-buttons>
    <oe-modal-horizontal-line></oe-modal-horizontal-line>

    @if(mode === 3) {
      <oe-modal-line [name]="'GENERAL.MODE' | translate" [channelAddress]="component.id + '/TariffState'"
                     [value]="tariffState" [converter]="CONVERT_TARIFF_STATE">
      </oe-modal-line>
      <oe-modal-horizontal-line></oe-modal-horizontal-line>
    }
    <oe-modal-info-line
      [info]="('EDGE.INDEX.WIDGETS.PV_GROUP_LIMIT' | translate)">
    </oe-modal-info-line>
    <oe-modal-horizontal-line></oe-modal-horizontal-line>
    <ion-row>
      <ion-col class="ion-padding-start">
        <ion-text color="medium">
          <p style="font-size: small">
            <b>{{'GENERAL.TARIFF' | translate}}:</b> {{'EDGE.INDEX.WIDGETS.PV_GROUP_LIMIT_DESC.TARIFF' | translate}}<br><br>
            <b>{{'GENERAL.SELL_TO_GRID' | translate}}:</b> {{'EDGE.INDEX.WIDGETS.PV_GROUP_LIMIT_DESC.SELL_TO_GRID' | translate}}<br><br>
            <b>{{'GENERAL.MAX_POWER' | translate}}:</b> {{'EDGE.INDEX.WIDGETS.PV_GROUP_LIMIT_DESC.MAX_POWER' | translate}}<br><br>
            <b>{{'GENERAL.OFF' | translate}}:</b> {{'EDGE.INDEX.WIDGETS.PV_GROUP_LIMIT_DESC.OFF' | translate}}
          </p>
        </ion-text>
      </ion-col>
    </ion-row>
  </oe-modal>
}
